/**
 * Utility functions and constants for dice component
 */

import type { DotPosition } from '../constants/types';

/**
 * Base64-encoded grass texture pattern (229x229px PNG)
 * Extracted from visual SVG files for reuse across dice instances
 */
export const GRASS_TEXTURE_BASE64 =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOUAAADlCAYAAACsyTAWAAAACXBIWXMAAAsSAAALEgHS3X78AAAIQklEQVR4nO3bbVMjtxKA0YbN///HmPvhRhXRbs3Ym7DqMedUuWzAEHbQM9K8JAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPih3nb/Av+xV/v38JjP3b/Af+nqg7j6/a/+b+I5VZCXjvSqA/iteF19jtf2WbyuPncpVxu8OcD5efU1XlOO8HPxufn5Ev7a/Qs86CzC6jG/n9eSQ8yPt7jwsrb7oF3FmB/vxefm78s/j2vJMa2ivBWfmx/Vz2qn80z5aIj5eRWlIK9tdfw4B/ke/4Q5Px/9rHa6RlkFOcdXvZ7fk38Gr6M6XhxBjte3+P/f/Ta9Z54tIxqH2THKHGQOcH5UYZolX9dqtpyDrFZVq1mzZZjdoqyCPHs4wfNz5B3tfFJnvB7j5iPuw4y4QJidolwF+at4/cgxJK9vFelt+txb3I+L1mF2ifIsyDnMeYacvzfi/rghio+5trMz6mP8VF+btQ2zQ5SPBDlHmfd8j1w85rUc3USS3/Me6zhbhtkhyoh/F+Slr0nxW44ul+Wvj8skvxY/q12Yu6NcXX+sgnyfvm91wXh+HfF1A2/f2Pwr1Sx4dAPJ/L5xdnblNn397eS93253lMMjZ1qHfGH4FvdhjvdVz1zT0ZJ1zIb5JGD+/re4nzHns7bj4612Rnk2S+YTOhH3IX7E/R0cZsrXdDRTznfzjFlxDnTIM2a+XzbS17boMFMeXZPMe7A5xo/4OkvOS5DL3L3BU3KYc5xzkOMxgsw79/y+MT7mMbTN6uD3ux0dQ84nec6C/Ih6llzFybWdnWHPf+vViaCzn73V7ihXZ1vHx8N8vPiRnp3c+bnOzhdUUa7ibHPuYUeU+frR6kaBeZZ8JMg2G5U2VuctVseP1Y3rf9yuY8rVDQP5tPYcZD7TKkgivt7/OuTb7KpLIjnUfDP7/PP/qA5nX6v/9aq6QWB1PXL7no3tqr9/vpY9h5mvX46TQnOY28bU+/lbvsVqSXF2x85qyQrDvGo6OudwdLx5dlLoW/3pKFcXdFdhPjIzCpOhOjY8WlG1inHYMVNWt0gdreVzmJE+D9nqBoHqZoGjcbgl0p3L1/Gc/+Gr5Wv1MWTVNepnZsrtdkUZsV7KrjjDyu/4nSVsxMZAd0YZcb6HWl3yMFvyiGfGyGq19sftjnK2uqC7+hhWVkvXvDPPs2KLJWynKCMe2yDi5L/Scix1ifIsRid4+B2r8VLNlm10iLLdRuGlPLpDbzMOO0QJXbQIU5TQjCihGVFCM6KEZkQJzYgSmhElNCNKaEaU0IwooRlRQjOihGZECc2IEpoRJTQjSmhGlNCMKKEZUUIzooRmRAnNiBKaESU0I0poRpTQjCihGVFCM6KEZkQJzYgSmhElNCNKaEaU0IwooRlRQjOihGZECc2IEpoRJTQjSmhGlNCMKKEZUUIzooRmRAnNiBKaESU0I0poRpTQjCihGVFCM6KEZkQJzYgSmhElNCNKaEaU0IwooRlRQjOihGZECc2IEpoRJTQjSmhGlNCMKKEZUUIzooRmRAnNiBKaESU0I0poRpTQjCihGVFCM6KEZkQJzYgSmhElNCNKaEaU0IwooRlRQjOihGZECc2IEpoRJTQjSmhGlNCMKKEZUUIzooRmRAnNiBKaESU0I0poRpTQjCihGVFCM6KEZkQJzYgSmhElNCNKaEaU0IwooRlRQjOihH987v4FIkTJ63ubHkdaBBnRI8o2G4OXswpx/ny78dchyojzDfPo3g4ql5klI/pEOTyycYTJmXkH/pY+txo/n9Njq05R5o2RN54YeVYOs1KFuDXM3VGe7Z3y3i3v9eBMNVNWYyePxW1h7oyy2jsdbYhH9nqwirCK8fPgsc2uKOe9Ud4I8+tqpqxmTpitgpzHTjUGn50ovsWOKFcbIy8dcojv8TVCQZKtDnPe4/mZ8scsX1d7os+IuMX9xqg2qtmSSh4PY8zk53mmvKXH9iAj9i5f5xhvcR7m2LA50Ahh/nSrmTE/D3lGzOMvYmOYf+36D0cd5rxRI+6DzN8z7/XysQKvLx/OVDvwaicesQ5y+xnYXVGOiHJkc3h5g+co55/1ufg+gb6e6vp1tWTNj2eD3GZHlHOQ43kEOc+WY+PMM+cqylt8jZzXVc2OEc8FmY8l82HT1jG0c/kaUS9H84Ye3oqP3+I+yOoMrlCvrzrzfrRkXS1dV0G2CXPn8nW4/f28ush7FOn4Q+TlR7VhhXldjwZZHUtWq6xbRHz8/ZjDjGgwTjrMlPMS9uisal6mzEHmMOPgmeuprj+O56OzravjyLNLIT92+ToHOT6ez6hGrJes8/fOYZopX9MzM2XeqVcz5GrZ2mKM7J4pI9ZRzn+I9/S5fDIoB9lij8e3WEW5umZdBbkKM6LBmNkd5eoMbGWeEfMfwJL15zhays7yJY8qyDnGiCbjZXeUEfdnSVdRjqVqxH2Y1R/k6GOup7o+meVVV35UQbZaukb0iDLifoPkMKuNVi1ZVntNXtccYj5+rEJsHWRExK/dv8CDzjba0TEFryvPjNUZ1o/4uoxtHWTENaJcbbSj48dqVuXa8t93dYljNTNWMbYLMqLvYK1un6ouEOfXR0tarq/aEec4q9fze+bva6nzgH3kelR1sfjs5gOup1oFVceQVYSXu1TWfaBWZ1jPLhofHV92//dyb3UmvVqKHkV4iSAjrjFIV/fBHoVo6fq6VqGdxRhxgSAjrjVoV7dajWfHkj/H6tiy+lp+3d4VB+5qSer48WdZHWeu3nMZVx+8jhl5iRBnV7hOCUcuHyEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQ0/8AKUEl3S061mQAAAAASUVORK5CYII=';

/**
 * Type definition for SVG path structure
 */
export interface SvgPaths {
  readonly BROWN_BASE: string;
  readonly DARK_GREEN: string;
  readonly OUTER_RECT: string;
  readonly INNER_RECT: string;
  readonly WHITE_FACE: string;
  readonly WHITE_FACE_HORIZ: string;
}

/**
 * SVG path definitions for dice layers
 * Extracted from visual designs to improve maintainability
 */
export const SVG_PATHS: SvgPaths = {
  BROWN_BASE:
    'M15.82 136.34V161.77C15.82 169.21 17.9 176.16 21.31 179.68C21.34 179.71 21.36 179.74 21.39 179.76C25.35 183.78 29.09 182.85 33.61 182.45C39.12 181.96 44.63 183.51 50.14 183.51C61.13 183.51 72.11 183.54 83.1 183.51C91 183.49 98.77 183.51 104.34 183.51C112.86 183.52 117.12 183.53 117.56 183.55C136.28 184.11 137.77 186.54 144.41 183.55C149 181.48 150.64 179.26 154.93 179.38C158.99 179.49 161.59 181.59 164.95 179C167.69 176.88 169.66 171.89 169.66 171.89C169.66 171.88 169.67 171.87 169.68 171.85C170.48 170.08 170.89 167.79 170.88 165.45C170.82 154.4 170.77 143.35 170.71 132.31C145.96 139.44 117.22 144.55 85.23 144.51C59.8 144.48 36.53 141.21 15.83 136.34H15.82Z',
  DARK_GREEN:
    'M15.81 127.07V160.63C16.87 163.65 18.64 167.71 21.39 170.49C25.35 174.51 29.09 173.58 33.61 173.18C39.12 172.69 44.63 174.24 50.14 174.24C61.13 174.24 72.11 174.27 83.1 174.24C91 174.22 98.77 174.24 104.34 174.24C112.86 174.25 117.12 174.26 117.56 174.28C136.28 174.84 137.77 177.27 144.4 174.28C148.99 172.21 150.63 169.99 154.92 170.11C158.98 170.22 161.58 172.32 164.94 169.73C167.68 167.61 169.65 162.62 169.65 162.62C170.2 161.4 170.61 160.29 170.89 159.48C170.83 147.33 170.77 135.18 170.71 123.04C145.96 130.17 117.22 135.28 85.23 135.24C59.8 135.21 36.53 131.94 15.83 127.07H15.81Z',
  OUTER_RECT:
    'M151.11 12.32H35.86C24.9524 12.32 16.11 21.1624 16.11 32.07V147.32C16.11 158.228 24.9524 167.07 35.86 167.07H151.11C162.018 167.07 170.86 158.228 170.86 147.32V32.07C170.86 21.1624 162.018 12.32 151.11 12.32Z',
  INNER_RECT:
    'M145.76 17.92H41C30.0924 17.92 21.25 26.7624 21.25 37.67V141.44C21.25 152.348 30.0924 161.19 41 161.19H145.76C156.668 161.19 165.51 152.348 165.51 141.44V37.67C165.51 26.7624 156.668 17.92 145.76 17.92Z',
  WHITE_FACE:
    'M135.41 28.04H51.26C40.3524 28.04 31.51 36.8824 31.51 47.79V131.09C31.51 141.998 40.3524 150.84 51.26 150.84H135.41C146.318 150.84 155.16 141.998 155.16 131.09V47.79C155.16 36.8824 146.318 28.04 135.41 28.04Z',
  WHITE_FACE_HORIZ:
    'M31.51 48.18L31.51 131.48C31.51 142.388 40.3524 151.23 51.26 151.23H135.41C146.318 151.23 155.16 142.388 155.16 131.48V48.18C155.16 37.2724 146.318 28.43 135.41 28.43H51.26C40.3524 28.43 31.51 37.2724 31.51 48.18Z'
};

/**
 * Configuration for dice SVG layout and styling
 */
export const DICE_CONFIG = {
  /** Default SVG viewBox dimensions */
  DEFAULT_VIEWBOX: '0 0 187 198',

  /** Default animation duration in milliseconds */
  DEFAULT_ANIMATION_DURATION: 1000,

  /** Default grass texture visibility */
  DEFAULT_SHOW_GRASS_TEXTURE: true,

  /** Dot styling constants */
  DOT: {
    RADIUS: 16.39,
    SHADOW_OFFSET: 1.54,
    COLOR: 'black',
    SHADOW_COLOR: '#333333',
    HIGHLIGHT: {
      OPACITY: 0.3,
      SIZE_MULTIPLIER: 0.35,
      OFFSET_MULTIPLIER: 0.3
    },
    SHADOW_OPACITY: 0.4
  },

  /** Center reference point for dot positioning */
  CENTER: {
    X: 93.34,
    Y: 89.44
  },

  /** Dot spacing for positioning calculations */
  SPACING: {
    HORIZONTAL: 32.5, // Half distance between left and right columns
    VERTICAL: 37.5 // Approximate vertical spacing between rows
  },

  /** Gradient color definitions */
  GRADIENTS: {
    BROWN_BASE: {
      START: '#72381B',
      END: '#754C24'
    },
    DARK_GREEN: {
      START: '#4B9E36',
      END: '#8CC63F'
    },
    OUTER_GREEN: {
      START: '#96C23B',
      END: '#BBD849'
    },
    WHITE_BORDER: {
      COLOR: '#B3B3B3',
      TRANSPARENT: 'white'
    }
  },

  /** 3D animation configuration */
  ANIMATION_3D: {
    ROTATION_X: [0, 180, 360],
    ROTATION_Y: [0, 180, 360],
    ROTATION_Z: [0, 90, 180, 270, 360],
    SCALE: [1, 1.15, 1],
    LIFT_Y: [0, -10, 0],
    EASING: [0.25, 0.46, 0.45, 0.94] as const
  },

  /** 3D shadow and filter configuration */
  SHADOW_3D: {
    BLUR_RADIUS: 3,
    OFFSET_X: 2,
    OFFSET_Y: 4,
    OPACITY: 0.4
  },

  /** Inner bevel filter configuration */
  BEVEL: {
    BLUR_RADIUS: 2,
    HIGHLIGHT_OFFSET: -2,
    SHADOW_OFFSET: 2,
    HIGHLIGHT_OPACITY: 0.5,
    SHADOW_OPACITY: 0.3
  },

  /** Gradient overlay opacity */
  GRADIENT_OVERLAY_OPACITY: 0.6,

  /** Disabled/rolling dice opacity */
  INACTIVE_OPACITY: 0.6
} as const;

/**
 * Generates a unique ID for SVG elements to prevent conflicts
 * when multiple dice are rendered on the same page.
 *
 * @param prefix - Prefix for the ID (e.g., 'paint0', 'pattern0')
 * @returns Unique ID string combining prefix with timestamp and random value
 *
 * @example
 * ```ts
 * const gradientId = generateUniqueId('paint0');
 * // Returns: "paint0_1699876543210_abc123def"
 * ```
 */
export function generateUniqueId(prefix: string): string {
  return `${prefix}_${String(Date.now())}_${Math.random().toString(36).substring(2, 11)}`;
}

/**
 * Generates a random dice face value (1-6), excluding the current value
 * to ensure visible face changes during rolling animation.
 *
 * Uses deterministic O(1) algorithm instead of probabilistic loop for guaranteed performance.
 *
 * @param currentValue - The current dice face to exclude (optional)
 * @returns Random dice value between 1 and 6
 *
 * @example
 * ```ts
 * getRandomDiceFace(3);
 * // Returns one of: 1, 2, 4, 5, 6 (never 3)
 *
 * getRandomDiceFace();
 * // Returns any value 1-6
 * ```
 */
export function getRandomDiceFace(currentValue?: number): number {
  // If no current value, return any face
  if (currentValue === undefined) {
    return Math.floor(Math.random() * 6) + 1;
  }

  // Select from 5 remaining values (excluding current)
  // Generate offset 0-4, then map to 1-6 skipping current value
  const offset = Math.floor(Math.random() * 5);
  const newValue = offset + 1;

  // If new value would be >= current, shift it up by 1 to skip current
  return newValue >= currentValue ? newValue + 1 : newValue;
}

/**
 * Calculates dot positions for a given dice value (1-6).
 * Uses standard dice dot patterns with programmatic positioning.
 *
 * @param value - The dice value (1-6)
 * @returns Array of dot positions with cx and cy coordinates
 *
 * @example
 * ```ts
 * const positions = calculateDotPositions(1);
 * // Returns: [{ cx: 93.34, cy: 89.44 }] // Center dot
 *
 * const positions = calculateDotPositions(6);
 * // Returns: 6 dot positions in two columns
 * ```
 */
export function calculateDotPositions(value: number): DotPosition[] {
  // Validate value is between 1-6, default to 1 if invalid
  const validValue = value >= 1 && value <= 6 ? value : 1;

  const { CENTER, SPACING } = DICE_CONFIG;
  const positions: DotPosition[] = [];

  // Dot pattern definitions based on visual SVG analysis
  switch (validValue) {
    case 1:
      // Single center dot
      positions.push({ cx: CENTER.X, cy: CENTER.Y });
      break;

    case 2:
      // Diagonal: top-right and bottom-left
      positions.push(
        { cx: CENTER.X + SPACING.HORIZONTAL, cy: CENTER.Y - SPACING.VERTICAL }, // Top-right
        { cx: CENTER.X - SPACING.HORIZONTAL, cy: CENTER.Y + SPACING.VERTICAL } // Bottom-left
      );
      break;

    case 3:
      // Diagonal (top-right, bottom-left) + center
      positions.push(
        { cx: CENTER.X + SPACING.HORIZONTAL, cy: CENTER.Y - SPACING.VERTICAL }, // Top-right
        { cx: CENTER.X, cy: CENTER.Y }, // Center
        { cx: CENTER.X - SPACING.HORIZONTAL, cy: CENTER.Y + SPACING.VERTICAL } // Bottom-left
      );
      break;

    case 4:
      // Four corners
      positions.push(
        { cx: CENTER.X - SPACING.HORIZONTAL, cy: CENTER.Y - SPACING.VERTICAL }, // Top-left
        { cx: CENTER.X + SPACING.HORIZONTAL, cy: CENTER.Y - SPACING.VERTICAL }, // Top-right
        { cx: CENTER.X - SPACING.HORIZONTAL, cy: CENTER.Y + SPACING.VERTICAL }, // Bottom-left
        { cx: CENTER.X + SPACING.HORIZONTAL, cy: CENTER.Y + SPACING.VERTICAL } // Bottom-right
      );
      break;

    case 5:
      // Four corners + center
      positions.push(
        { cx: CENTER.X - SPACING.HORIZONTAL, cy: CENTER.Y - SPACING.VERTICAL }, // Top-left
        { cx: CENTER.X + SPACING.HORIZONTAL, cy: CENTER.Y - SPACING.VERTICAL }, // Top-right
        { cx: CENTER.X, cy: CENTER.Y }, // Center
        { cx: CENTER.X - SPACING.HORIZONTAL, cy: CENTER.Y + SPACING.VERTICAL }, // Bottom-left
        { cx: CENTER.X + SPACING.HORIZONTAL, cy: CENTER.Y + SPACING.VERTICAL } // Bottom-right
      );
      break;

    case 6:
      // Two columns of 3 dots each
      positions.push(
        // Left column
        { cx: CENTER.X - SPACING.HORIZONTAL, cy: CENTER.Y - SPACING.VERTICAL }, // Top-left
        { cx: CENTER.X - SPACING.HORIZONTAL, cy: CENTER.Y }, // Middle-left
        { cx: CENTER.X - SPACING.HORIZONTAL, cy: CENTER.Y + SPACING.VERTICAL }, // Bottom-left
        // Right column
        { cx: CENTER.X + SPACING.HORIZONTAL, cy: CENTER.Y - SPACING.VERTICAL }, // Top-right
        { cx: CENTER.X + SPACING.HORIZONTAL, cy: CENTER.Y }, // Middle-right
        { cx: CENTER.X + SPACING.HORIZONTAL, cy: CENTER.Y + SPACING.VERTICAL } // Bottom-right
      );
      break;
  }

  return positions;
}
